import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../../../../baseClasses/BaseComponent';
import photoPlaceHolder from '../../../../../../../assets/images/photo-place-holder.svg';
import photoPlaceHolderHoriz from '../../../../../../../assets/images/photo-place-holder-horiz.svg';
import dataModel from '../../../../../../../models/DataModel';
import './PhotoGridCard.scss';

// Change Card to the appropriate name
export class PhotoGridCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null, attachment: props.attachment };
    this.interval = null;
  }

  componentDidMount() {
    if (this.props.uploadImage) {
      this.animateProgress();
    }
    this.handleSizing();

    if (this.props.attachment && this.props.attachment.id) {
      dataModel.attachmentsDAO.getAttachment(this.props.attachment.id, { force: !this.props.attachment.upload, recordDescriptor: { attachment: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } } }).then(attachment => {
        // NOTE: getAttachment may return null for a placeholder passed to us but not yet in store...
        this.setState({ attachment: attachment != null ? attachment : this.props.attachment });
      });
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.attachment != this.props.attachment && this.props.attachment) {
      dataModel.attachmentsDAO.getAttachment(this.props.attachment.id, { force: !this.props.attachment.upload, recordDescriptor: { attachment: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } } }).then(attachment => {
        this.setState({ attachment });
      });
    }
  }

  handleSelection(e) {
    e.stopPropagation();
    if (this.props.handlePhotoSelection) {
      this.props.handlePhotoSelection(this.state.attachment);
    }
  }

  handleSizing() {
    if (this.element) {
      const parent = this.element.parentElement;
      if (parent) {
        const rect = parent.getBoundingClientRect();
        if (this.props.hideName) {
          const width = rect.width;
          const height = Math.floor(width * 102 / 120);
          this.setState({ height: height });
        }
        else {
          const height = rect.height;
          const width = Math.floor(height * 120 / 102);
          this.setState({ width: width });
        }
      }
    }
  }

  animateProgress() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    let width = 0;
    const self = this;
    this.interval = setInterval(() => {
      if (self.progressElement && self.loadingElement) {
        let parentRect = self.loadingElement.getBoundingClientRect();

        width++;
        if (width >= parentRect.width) {
          width = 0;
        }
        self.setState({ progressWidth: width });
      }
    }, this.props.mobileBridge.isMobile ? 20 : 5);
  }

  handleSetLIElement(element) {
    if (element) {
      this.loadingElement = element;
    }
    if (this.progressElement && this.loadingElement && !this.interval) {
      this.animateProgress();
    }
  }

  handleSetPElement(element) {
    if (element) {
      this.progressElement = element;
    }
    if (this.progressElement && this.loadingElement && !this.interval) {
      this.animateProgress();
    }
  }

  render() {
    const { hideName, uploadImage, single, medium } = this.props;
    const { attachment } = this.state;
    let src; 
    if (uploadImage) {
      src = hideName ? photoPlaceHolderHoriz : photoPlaceHolder;
    } else if (attachment.prefetchedImage && dataModel.isOffline) {
      src = attachment.prefetchedImage;
    } else if (attachment.upload_thumb){
      src = attachment.upload_thumb instanceof Blob ? URL.createObjectURL(attachment.upload_thumb) : attachment.upload_thumb;
    } else if (attachment.upload && (attachment.upload instanceof Blob)) {
      src = URL.createObjectURL(attachment.upload);
    } else {
      src = this.props.mobileBridge.isMobile ? (attachment._thumbnailForRetention && attachment._thumbnailForRetention.src ? attachment._thumbnailForRetention.src : attachment.upload_thumb) : attachment.upload;
    }
    this.id = Math.floor(Math.random() * 100);

    const style = !hideName
      ? {}
      : {};
    const progressStyle = this.state.progressWidth
      ? { width: this.state.progressWidth }
      : {};

    let indicator = null;
    if (uploadImage) {
      indicator = <div
        className="loading-indicator"
        id={'loading-indicator-' + this.id}
        ref={element => {
          this.handleSetLIElement(element);
        }}
      >
        <div
          className="progress-indicator"
          id={'progress-indicator-' + this.id}
          ref={element => {
            this.handleSetPElement(element);
          }}
          style={progressStyle}
        />
      </div>;

    }

    if (this.props.mobileBridge.isMobile && !medium) {
      return (
        <div className={'photo-grid-card' + (this.props.noBorder ? ' no-border' : '')} onClick={this.handleSelection}>
          <img className="image-holder" src={src} alt="Attachment" />
          <div className="image-title">{attachment ? attachment.name : ''}</div>
          <div className="holder">
            {indicator}
          </div>  
        </div>
      );
    } else {
      return (
        <div
          className={'web-photo-grid-card ' + (medium ? '  medium' : hideName && !single ? 'small' : '') + (this.props.noBorder ? ' no-border' : '')}
          onClick={this.handleSelection}
          ref={element => {
            this.element = element;
          }}
        >
          <img
            className={'web-image-holder ' + (!hideName ? 'room-for-name' : '' + (!single? 'small': ''))}
            src={src}
            alt="Attachment"
            style={style}
          />
          {!hideName && (
            <div className="web-image-title">
              {attachment ? attachment.name : ''}
            </div>
          )}
          {indicator}
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    mobileBridge: dataModel.mobileBridge,
  };
};

export default connect(mapStateToProps, null)(PhotoGridCard);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/PhotoUpload/TaskCompletionStepPhotoGrid/PhotoGridCard/index.js